import { useThemeObserver } from 'src/common/hooks/use-theme-observer';
export const ThemeObserverWrapper = () => {
  // Need to have a wrapper because of context errors
  useThemeObserver();
  return null;
};